import React, { useState } from "react";
import { addInsuranceInfo } from "../PHP/ApiCalls";
import { useSelector } from "react-redux";

import { states } from "../Screens/states";

const InsuranceForm = ({ setCurrentStep }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [validationError, setValidationError] = useState(null);
  const [patientRelation, setPatientRelation] = useState("");
  const [planName, setPlanName] = useState("");
  const [policyNumber, setPolicyNumber] = useState("");
  const [memberId, setMemberId] = useState("");

  // Fields shown when "Self" is selected
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [mi, setMi] = useState("");
  const [dob, setDob] = useState("");
  const [sex, setSex] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zipCode, setZipCode] = useState("");

  const { user } = useSelector((state) => state.auth);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedExtensions = [
        ".jpg",
        ".png",
        ".pdf",
        ".doc",
        ".docx",
        ".xls",
        ".xlsx",
      ];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (allowedExtensions.includes("." + fileExtension)) {
        setSelectedFile(file);
        setValidationError(null);
      } else {
        setSelectedFile(null);
        setValidationError(
          "Invalid file extension. Please select a valid file type."
        );
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (
      !selectedFile ||
      !patientRelation ||
      !planName ||
      !policyNumber ||
      !memberId
    ) {
      alert("Please fill out all required fields and upload a file.");
      return;
    }

    const formData = new FormData();
    formData.append("insurance_file", selectedFile);
    formData.append("patient_id", user.PatientID);
    formData.append("patient_relation", patientRelation);
    formData.append("plan_name", planName);
    formData.append("policy_number", policyNumber);
    formData.append("member_id", memberId);

    if (patientRelation === "Self") {
      formData.append("last_name", lastName);
      formData.append("first_name", firstName);
      formData.append("mi", mi);
      formData.append("dob", dob);
      formData.append("sex", sex);
      formData.append("address", address);
      formData.append("city", city);
      formData.append("state", state);
      formData.append("zip_code", zipCode);
    }

    try {
      const response = await addInsuranceInfo(formData);
      console.log("Form submitted successfully:", response);
      setCurrentStep((prevStep) => prevStep + 1);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <div className="ins_container">
      <div className="form_inner">
        <h3>Insurance Card</h3>
        <form onSubmit={handleSubmit}>
          {/* File Upload */}
          <input
            type="file"
            name="insurance_file"
            accept=".jpg,.png,.pdf,.doc,.docx,.xls,.xlsx"
            onChange={handleFileChange}
          />
          {validationError && <p style={{ color: "red" }}>{validationError}</p>}

          <div className="patient_insured_relation">
            <div className="radio_group">
              <label>
                <input
                  type="radio"
                  name="patient_relation"
                  value="Self"
                  checked={patientRelation === "Self"}
                  onChange={(e) => setPatientRelation(e.target.value)}
                />
                Self
              </label>
              <label>
                <input
                  type="radio"
                  name="patient_relation"
                  value="Spouse"
                  checked={patientRelation === "Spouse"}
                  onChange={(e) => setPatientRelation(e.target.value)}
                />
                Spouse
              </label>
              <label>
                <input
                  type="radio"
                  name="patient_relation"
                  value="Child"
                  checked={patientRelation === "Child"}
                  onChange={(e) => setPatientRelation(e.target.value)}
                />
                Child
              </label>
              <label>
                <input
                  type="radio"
                  name="patient_relation"
                  value="Other"
                  checked={patientRelation === "Other"}
                  onChange={(e) => setPatientRelation(e.target.value)}
                />
                Other
              </label>
            </div>
          </div>

          {/* Plan Name, Group/Policy #, Member ID */}
          <div className="form_container_custom">
            <div className="form_group">
              <label>
                Plan Name *
                <input
                  type="text"
                  name="plan_name"
                  value={planName}
                  onChange={(e) => setPlanName(e.target.value)}
                  required
                />
              </label>
            </div>
            <div className="form_group">
              <label>
                Group/Policy # *
                <input
                  type="text"
                  name="policy_number"
                  value={policyNumber}
                  onChange={(e) => setPolicyNumber(e.target.value)}
                  required
                />
              </label>
            </div>
            <div className="form_group">
              <label>
                Member ID *
                <input
                  type="text"
                  name="member_id"
                  value={memberId}
                  onChange={(e) => setMemberId(e.target.value)}
                  required
                />
              </label>
            </div>
          </div>

          {patientRelation === "Self" && (
            <div className="self_form_fields">
              <h4>Insured</h4>
              <div className="form_container">
                <div className="form_group">
                  <label>Last Name</label>
                  <input type="text" name="last_name" />
                </div>
                <div className="form_group">
                  <label>First Name</label>
                  <input type="text" name="first_name" />
                </div>
                <div className="form_group">
                  <label>MI</label>
                  <input type="text" name="mi" />
                </div>
                <div className="form_group">
                  <label>DOB</label>
                  <input type="date" name="dob" />
                </div>
                <div className="form_group">
                  <label>Sex</label>
                  <select name="sex">
                    <option value="">Select</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
                <div className="form_group">
                  <label>Address</label>
                  <input type="text" name="address" />
                </div>
                <div className="form_group">
                  <label>City</label>
                  <input type="text" name="city" />
                </div>
                <div className="form_group">
                  <label>State</label>
                  <select
                    name="state"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                  >
                    <option value="">Select a State</option>
                    {states.map((stateItem) => (
                      <option key={stateItem.value} value={stateItem.value}>
                        {stateItem.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form_group">
                  <label>Zip Code</label>
                  <input type="text" name="zip_code" />
                </div>
              </div>
            </div>
          )}

          {patientRelation !== "Self" && (
            <div className="self_form_fields">
              <h4>Insured</h4>
              <div className="form_container">
                <div className="form_group">
                  <label>Last Name</label>
                  <input
                    type="text"
                    name="lastname2"
                    placeholder="Enter Last Name"
                  />
                </div>
                <div className="form_group">
                  <label>First Name</label>
                  <input
                    type="text"
                    name="firstname2"
                    placeholder="Enter First Name"
                  />
                </div>
                <div className="form_group">
                  <label>Middle Name</label>
                  <input
                    type="text"
                    name="middlename2"
                    placeholder="Enter Middle Name"
                  />
                </div>
                <div className="form_group">
                  <label>DOB</label>
                  <input type="date" name="dob2" />
                </div>
                <div className="form_group">
                  <label>Sex</label>
                  <div>
                    <select name="sex">
                      <option value="">Select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Submit Button */}
          <button class="insurance_button" type="submit">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default InsuranceForm;
